/**
 * Builds the user-facing share link for a study-share token.
 *
 * The `r` region hint is required for cross-region resolution: `/study/:id` is a
 * public route (no JWT), so without it the SPA resolves `/share/{token}` against
 * the first configured region and 404s for shares hosted in any other region.
 * The backend email builder (ShareStudyEmail.ShareUrlFor) emits the same shape.
 * `region` is null when unknown (e.g. single-region/local dev) — the link then
 * relies on the default-region fallback, matching pre-multi-region behavior.
 */
export function buildShareUrl(origin, studyId, token, region) {
    const base = `${origin}/study/${studyId}?token=${encodeURIComponent(token)}`;
    return region ? `${base}&r=${encodeURIComponent(region)}` : base;
}
